import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, HostListener, OnChanges, SimpleChanges } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CdkTrapFocus } from "@angular/cdk/a11y";
import { SharedModule } from "../../shared.module";
import { LucideAngularModule, X } from "lucide-angular";

@Component({
  selector: "app-modal",
  standalone: true,
  imports: [CommonModule, SharedModule, LucideAngularModule, CdkTrapFocus],
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"]
})
export class ModalComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isOpen: boolean = false;
  @Input() title: string = "";
  @Input() subtitle: string = "";
  @Input() description: string = "";
  @Input() closeButtonText?: string;
  @Input() actionButtonText: string = "";
  @Input() showCloseIcon: boolean = true;
  @Input() closeOnClickOutside: boolean = true;
  @Input() actionButtonDisabled: boolean = false;
  @Input() width: string = "500px";
  @Input() isRemovable: boolean = true; // Nuova opzione per modali non rimovibili
  @Input() customClass: string = "";
  @Input() trapFocus: boolean = true;
  @Output() onClose = new EventEmitter<void>();
  @Output() onAction = new EventEmitter<void>();

  // Icons
  closeIcon = X;

  constructor() {}

  ngOnInit(): void {
    if (this.isOpen) {
      this.disableBodyScroll();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isOpen"] && changes["isOpen"].currentValue === true) {
      this.disableBodyScroll();
    } else if (changes["isOpen"] && changes["isOpen"].currentValue === false) {
      this.enableBodyScroll();
    }
  }

  ngOnDestroy(): void {
    this.enableBodyScroll();
  }

  @HostListener("document:keydown.escape", ["$event"])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onEscapeKey(_event: KeyboardEvent): void {
    if (this.isOpen && this.isRemovable) {
      this.closeModal();
    }
  }

  /**
   * Chiude il modale se è rimovibile
   */
  closeModal(): void {
    if (this.isRemovable) {
      this.onClose.emit();
    }
  }

  /**
   * Emette l'evento di azione del modale
   */
  actionModal(): void {
    this.onAction.emit();
  }

  /**
   * Gestisce il click sull'overlay per chiudere il modale
   * @param event - Evento di click
   */
  onOverlayClick(event: Event): void {
    if (event.target === event.currentTarget && this.closeOnClickOutside && this.isRemovable) {
      this.closeModal();
    }
  }

  private disableBodyScroll(): void {
    document.body.style.overflow = "hidden";
  }

  private enableBodyScroll(): void {
    document.body.style.overflow = "";
  }
} 